import { LAYOUT_NAME_PG_GRID, LAYOUT_PG_GRID } from '../layout-types';
import { PgLayoutCardsRowTypeOptions } from '../pro-gallery';
export const POST_LIST_WIDGET_DEFAULTS = {
    margins: 10,
    sidesPadding: 16,
    postSize: 254,
    contentHeight: 156,
    imageRatio: 2,
    spacing: 12,
    layoutName: LAYOUT_NAME_PG_GRID,
    layoutType: LAYOUT_PG_GRID,
    layoutCardsRowType: PgLayoutCardsRowTypeOptions.FitToScreen,
    layoutPostsPerRow: 3,
};
export var PostListWidgetPaginationType;
(function (PostListWidgetPaginationType) {
    PostListWidgetPaginationType[PostListWidgetPaginationType["NumberOfPosts"] = 0] = "NumberOfPosts";
    PostListWidgetPaginationType[PostListWidgetPaginationType["Paginated"] = 1] = "Paginated";
})(PostListWidgetPaginationType || (PostListWidgetPaginationType = {}));
export var PostListWidgetSliderArrowsPosition;
(function (PostListWidgetSliderArrowsPosition) {
    PostListWidgetSliderArrowsPosition[PostListWidgetSliderArrowsPosition["OnGallery"] = 0] = "OnGallery";
    PostListWidgetSliderArrowsPosition[PostListWidgetSliderArrowsPosition["OutsideGallery"] = 1] = "OutsideGallery";
})(PostListWidgetSliderArrowsPosition || (PostListWidgetSliderArrowsPosition = {}));
export const getArrowsPositionOptions = (t) => [
    {
        value: PostListWidgetSliderArrowsPosition.OnGallery,
        label: t('post-list-widget.layout-tab.slider-arrows-position-on-post'),
    },
    {
        value: PostListWidgetSliderArrowsPosition.OutsideGallery,
        label: t('post-list-widget.layout-tab.slider-arrows-position-outside-post'),
    },
];
export const postListWidgetStyleParams = {
    postListWidgetBackgroundColor: {
        key: 'postListWidgetBackgroundColor',
        defaultValue: 'color-5',
        defaultOpacity: 0,
    },
    postListWidgetSliderArrowsColor: {
        key: 'postListWidgetSliderArrowsColor',
        defaultValue: 'color-5',
    },
    postListWidgetBackgroundColorMobile: {
        key: 'postListWidgetBackgroundColorMobile',
        defaultValue: 'color-5',
        defaultOpacity: 0,
    },
    postListWidgetSliderArrowsColorMobile: {
        key: 'postListWidgetSliderArrowsColorMobile',
        defaultValue: 'color-5',
    },
    postListWidgetIsFeatured: {
        key: 'postListWidgetIsFeatured',
        defaultValue: false,
    },
    postListWidgetEntityCount: {
        key: 'postListWidgetEntityCount',
        defaultValue: 3,
        minValue: 1,
        maxValue: 50,
    },
    postListWidgetPaginationType: {
        key: 'postListWidgetPaginationType',
        defaultValue: PostListWidgetPaginationType.NumberOfPosts,
        options: (t) => [
            {
                value: PostListWidgetPaginationType.NumberOfPosts,
                label: t('post-list-widget.settings-tab.pagination-number-of-posts'),
            },
            {
                value: PostListWidgetPaginationType.Paginated,
                label: t('post-list-widget.settings-tab.pagination-with-page-numbers'),
            },
        ],
    },
    postListWidgetPostsPerPage: {
        key: 'postListWidgetPostsPerPage',
        defaultValue: 3,
        minValue: 1,
        maxValue: 50,
    },
    postListWidgetSliderLoop: {
        key: 'postListWidgetSliderLoop',
        defaultValue: false,
    },
    postListWidgetSliderAutoSlide: {
        key: 'postListWidgetSliderAutoSlide',
        defaultValue: false,
    },
    postListWidgetSliderPauseTime: {
        key: 'postListWidgetSliderPauseTime',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    postListWidgetSliderShowArrows: {
        key: 'postListWidgetSliderShowArrows',
        defaultValue: true,
    },
    postListWidgetSliderArrowsPosition: {
        key: 'postListWidgetSliderArrowsPosition',
        defaultValue: PostListWidgetSliderArrowsPosition.OnGallery,
        options: getArrowsPositionOptions,
    },
    postListWidgetSliderArrowsSize: {
        key: 'postListWidgetSliderArrowsSize',
        defaultValue: 18,
        minValue: 6,
        maxValue: 180,
    },
    postListWidgetSliderLoopMobile: {
        key: 'postListWidgetSliderLoopMobile',
        defaultValue: false,
    },
    postListWidgetSliderAutoSlideMobile: {
        key: 'postListWidgetSliderAutoSlideMobile',
        defaultValue: true,
    },
    postListWidgetSliderPauseTimeMobile: {
        key: 'postListWidgetSliderPauseTimeMobile',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    postListWidgetSliderShowArrowsMobile: {
        key: 'postListWidgetSliderShowArrowsMobile',
        defaultValue: true,
    },
    postListWidgetSliderArrowsPositionMobile: {
        key: 'postListWidgetSliderArrowsPositionMobile',
        defaultValue: PostListWidgetSliderArrowsPosition.OnGallery,
        options: getArrowsPositionOptions,
    },
    postListWidgetSliderArrowsSizeMobile: {
        key: 'postListWidgetSliderArrowsSizeMobile',
        defaultValue: 18,
        maxValue: 180,
        minValue: 6,
    },
};
export const postListWidgetStyleParamsByDevice = {
    desktop: {
        sliderLoop: postListWidgetStyleParams.postListWidgetSliderLoop,
        widgetBackgroundColor: postListWidgetStyleParams.postListWidgetBackgroundColor,
        sliderAutoSlide: postListWidgetStyleParams.postListWidgetSliderAutoSlide,
        sliderPauseTime: postListWidgetStyleParams.postListWidgetSliderPauseTime,
        sliderShowArrows: postListWidgetStyleParams.postListWidgetSliderShowArrows,
        sliderArrowsPosition: postListWidgetStyleParams.postListWidgetSliderArrowsPosition,
        sliderArrowsSize: postListWidgetStyleParams.postListWidgetSliderArrowsSize,
        sliderArrowsColor: postListWidgetStyleParams.postListWidgetSliderArrowsColor,
    },
    mobile: {
        sliderLoop: postListWidgetStyleParams.postListWidgetSliderLoopMobile,
        widgetBackgroundColor: postListWidgetStyleParams.postListWidgetBackgroundColorMobile,
        sliderAutoSlide: postListWidgetStyleParams.postListWidgetSliderAutoSlideMobile,
        sliderPauseTime: postListWidgetStyleParams.postListWidgetSliderPauseTimeMobile,
        sliderShowArrows: postListWidgetStyleParams.postListWidgetSliderShowArrowsMobile,
        sliderArrowsPosition: postListWidgetStyleParams.postListWidgetSliderArrowsPositionMobile,
        sliderArrowsSize: postListWidgetStyleParams.postListWidgetSliderArrowsSizeMobile,
        sliderArrowsColor: postListWidgetStyleParams.postListWidgetSliderArrowsColorMobile,
    },
};
export var RelatedPostsLabel;
(function (RelatedPostsLabel) {
    RelatedPostsLabel[RelatedPostsLabel["Related"] = 0] = "Related";
    RelatedPostsLabel[RelatedPostsLabel["Recent"] = 1] = "Recent";
})(RelatedPostsLabel || (RelatedPostsLabel = {}));
export var SeeAllLinkLayoutType;
(function (SeeAllLinkLayoutType) {
    SeeAllLinkLayoutType[SeeAllLinkLayoutType["Text"] = 0] = "Text";
    SeeAllLinkLayoutType[SeeAllLinkLayoutType["Button"] = 1] = "Button";
})(SeeAllLinkLayoutType || (SeeAllLinkLayoutType = {}));
export const relatedPostsWidgetStyleParams = {
    'blog-isRelatedPostsEnabled': {
        key: 'blog-isRelatedPostsEnabled',
    },
    'blog-isRelatedPostsLabelEnabled': {
        key: 'blog-isRelatedPostsLabelEnabled',
    },
    'blog-isSeeAllPostsLinkEnabled': {
        key: 'blog-isSeeAllPostsLinkEnabled',
    },
    'blog-mobile-isRelatedPostsEnabled': {
        key: 'blog-mobile-isRelatedPostsEnabled',
    },
    'blog-mobile-isRelatedPostsLabelEnabled': {
        key: 'blog-mobile-isRelatedPostsLabelEnabled',
    },
    'blog-mobile-isSeeAllPostsLinkEnabled': {
        key: 'blog-mobile-isSeeAllPostsLinkEnabled',
    },
    'mobile-relatedPostsLabel': {
        key: 'mobile-relatedPostsLabel',
        defaultValue: RelatedPostsLabel.Related,
    },
    'post-list-postCount': {
        key: 'post-list-postCount',
        defaultValue: 3,
        minValue: 1,
        maxValue: 50,
    },
    relatedPostsLabel: {
        key: 'relatedPostsLabel',
        defaultValue: RelatedPostsLabel.Related,
    },
    'see-all-link-button-backgroundColor': {
        key: 'see-all-link-button-backgroundColor',
        defaultValue: 'color-8',
        defaultOpacity: 1,
    },
    'see-all-link-button-backgroundColorHover': {
        key: 'see-all-link-button-backgroundColorHover',
        defaultValue: 'color-8',
        defaultOpacity: 0.7,
    },
    'see-all-link-button-borderColor': {
        key: 'see-all-link-button-borderColor',
        defaultValue: 'color-8',
        defaultOpacity: 1,
    },
    'see-all-link-button-borderColorHover': {
        key: 'see-all-link-button-borderColorHover',
        defaultValue: 'color-8',
        defaultOpacity: 0.7,
    },
    'see-all-link-button-borderWidth': {
        key: 'see-all-link-button-borderWidth',
        defaultValue: 0,
        minValue: 0,
        maxValue: 10,
    },
    'see-all-link-button-cornerRadius': {
        key: 'see-all-link-button-cornerRadius',
        defaultValue: 0,
        minValue: 0,
        maxValue: 100,
    },
    'see-all-link-button-textColor': {
        key: 'see-all-link-button-textColor',
        defaultValue: 'color-1',
    },
    'see-all-link-button-textColorHover': {
        key: 'see-all-link-button-textColorHover',
        defaultValue: 'color-1',
        defaultOpacity: 1,
    },
    'see-all-link-button-uppercase': {
        key: 'see-all-link-button-uppercase',
        defaultValue: false,
    },
    'see-all-link-enabled': {
        key: 'see-all-link-enabled',
        defaultValue: true,
    },
    'see-all-link-mobile-enabled': {
        key: 'see-all-link-mobile-enabled',
        defaultValue: true,
    },
    'see-all-link-text-textColor': {
        key: 'see-all-link-text-textColor',
        defaultValue: 'color-8',
    },
    'see-all-link-text-textColorHover': {
        key: 'see-all-link-text-textColorHover',
        defaultValue: 'color-8',
        defaultOpacity: 0.7,
    },
    'see-all-link-text-textFont': {
        key: 'see-all-link-text-textFont',
        defaultTheme: 'font_8',
        defaultSize: 14,
        minSize: 10,
        maxSize: 24,
    },
    'see-all-link-text-uppercase': {
        key: 'see-all-link-text-uppercase',
        defaultValue: false,
    },
    'see-all-link-layoutType': {
        key: 'see-all-link-layoutType',
        defaultValue: SeeAllLinkLayoutType.Text,
        options: (t) => [
            {
                value: SeeAllLinkLayoutType.Text,
                label: t('related-posts-widget.see-all-link-settings.text-layout-label'),
            },
            {
                value: SeeAllLinkLayoutType.Button,
                label: t('related-posts-widget.see-all-link-settings.button-layout-label'),
            },
        ],
    },
    'slider-arrowsColor': {
        key: 'slider-arrowsColor',
        defaultValue: 'color-5',
    },
    'slider-autoSlide': {
        key: 'slider-autoSlide',
        defaultValue: false,
    },
    'slider-loop': {
        key: 'slider-loop',
        defaultValue: false,
    },
    'slider-mobile-arrowsColor': {
        key: 'slider-mobile-arrowsColor',
        defaultValue: 'color-5',
    },
    'slider-mobile-autoSlide': {
        key: 'slider-mobile-autoSlide',
        defaultValue: true,
    },
    'slider-mobile-loop': {
        key: 'slider-mobile-loop',
        defaultValue: false,
    },
    'slider-mobile-showArrows': {
        key: 'slider-mobile-showArrows',
        defaultValue: true,
    },
    'slider-showArrows': {
        key: 'slider-showArrows',
        defaultValue: true,
    },
    'slider-arrowsPosition': {
        key: 'slider-arrowsPosition',
        defaultValue: PostListWidgetSliderArrowsPosition.OnGallery,
        options: getArrowsPositionOptions,
    },
    'slider-arrowsSize': {
        key: 'slider-arrowsSize',
        defaultValue: 18,
        minValue: 6,
        maxValue: 180,
    },
    'slider-mobile-arrowsPosition': {
        key: 'slider-mobile-arrowsPosition',
        defaultValue: PostListWidgetSliderArrowsPosition.OnGallery,
        options: getArrowsPositionOptions,
    },
    'slider-mobile-arrowsSize': {
        key: 'slider-mobile-arrowsSize',
        defaultValue: 18,
        minValue: 6,
        maxValue: 180,
    },
    'slider-mobile-pauseTime': {
        key: 'slider-mobile-pauseTime',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    'slider-pauseTime': {
        key: 'slider-pauseTime',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    'widget-backgroundColor': {
        key: 'widget-backgroundColor',
        defaultValue: 'color-1',
        defaultOpacity: 0,
    },
    'widget-mobile-backgroundColor': {
        key: 'widget-mobile-backgroundColor',
        defaultValue: 'color-1',
        defaultOpacity: 0,
    },
    'widget-title-enabled': {
        key: 'widget-title-enabled',
        defaultValue: true,
    },
    'widget-title-mobile-enabled': {
        key: 'widget-title-mobile-enabled',
        defaultValue: true,
    },
    'widget-title-textColor': {
        key: 'widget-title-textColor',
        defaultValue: 'color-5',
    },
    'widget-title-textFont': {
        key: 'widget-title-textFont',
        defaultTheme: 'font_8',
        defaultSize: 22,
        minSize: 10,
        maxSize: 24,
    },
    'see-all-link-button-textFont': {
        key: 'see-all-link-button-textFont',
        defaultTheme: 'font_8',
        defaultSize: 14,
        minSize: 10,
        maxSize: 24,
    },
    'see-all-link-button-horizontalPadding': {
        key: 'see-all-link-button-horizontalPadding',
        defaultValue: 12,
        minValue: 0,
        maxValue: 100,
    },
    'see-all-link-button-verticalPadding': {
        key: 'see-all-link-button-verticalPadding',
        defaultValue: 6,
        minValue: 0,
        maxValue: 100,
    },
};
export const relatedPostsWidgetStyleParamsByDevice = {
    desktop: {
        sliderArrowsColor: relatedPostsWidgetStyleParams['slider-arrowsColor'],
        sliderArrowsPosition: relatedPostsWidgetStyleParams['slider-arrowsPosition'],
        sliderArrowsSize: relatedPostsWidgetStyleParams['slider-arrowsSize'],
        sliderAutoSlide: relatedPostsWidgetStyleParams['slider-autoSlide'],
        sliderLoop: relatedPostsWidgetStyleParams['slider-loop'],
        sliderPauseTime: relatedPostsWidgetStyleParams['slider-pauseTime'],
        sliderShowArrows: relatedPostsWidgetStyleParams['slider-showArrows'],
        widgetBackgroundColor: relatedPostsWidgetStyleParams['widget-backgroundColor'],
    },
    mobile: {
        sliderArrowsColor: relatedPostsWidgetStyleParams['slider-mobile-arrowsColor'],
        sliderArrowsPosition: relatedPostsWidgetStyleParams['slider-mobile-arrowsPosition'],
        sliderArrowsSize: relatedPostsWidgetStyleParams['slider-mobile-arrowsSize'],
        sliderAutoSlide: relatedPostsWidgetStyleParams['slider-mobile-autoSlide'],
        sliderLoop: relatedPostsWidgetStyleParams['slider-mobile-loop'],
        sliderPauseTime: relatedPostsWidgetStyleParams['slider-mobile-pauseTime'],
        sliderShowArrows: relatedPostsWidgetStyleParams['slider-mobile-showArrows'],
        widgetBackgroundColor: relatedPostsWidgetStyleParams['widget-mobile-backgroundColor'],
    },
};
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_ENABLED = 'blog-isRelatedPostsEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_ENABLED_PATH = `style.booleans.${IS_RELATED_POSTS_ENABLED}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_ENABLED_MOBILE = 'blog-mobile-isRelatedPostsEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_ENABLED_MOBILE_PATH = `style.booleans.${IS_RELATED_POSTS_ENABLED_MOBILE}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_LABEL_ENABLED = 'blog-isRelatedPostsLabelEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_LABEL_ENABLED_PATH = `style.booleans.${IS_RELATED_POSTS_LABEL_ENABLED}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_LABEL_ENABLED_MOBILE = 'blog-mobile-isRelatedPostsLabelEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_RELATED_POSTS_LABEL_ENABLED_MOBILE_PATH = `style.booleans.${IS_RELATED_POSTS_LABEL_ENABLED_MOBILE}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_SEE_ALL_POSTS_LINK_ENABLED = 'blog-isSeeAllPostsLinkEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_SEE_ALL_POSTS_LINK_ENABLED_PATH = `style.booleans.${IS_SEE_ALL_POSTS_LINK_ENABLED}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_SEE_ALL_POSTS_LINK_ENABLED_MOBILE = 'blog-mobile-isSeeAllPostsLinkEnabled';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const IS_SEE_ALL_POSTS_LINK_ENABLED_MOBILE_PATH = `style.booleans.${IS_SEE_ALL_POSTS_LINK_ENABLED_MOBILE}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL = 'relatedPostsLabel';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL_MOBILE = 'mobile-relatedPostsLabel';
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL_PATH = `style.numbers.${RELATED_POSTS_LABEL}`;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL_MOBILE_PATH = `style.numbers.${RELATED_POSTS_LABEL_MOBILE}`;
/** @deprecated use {@link RelatedPostsLabel} */
export const RELATED_POSTS_LABEL_OPTIONS = { related: 0, recent: 1 };
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL_OPTIONS_BY_ID = {
    0: 'related',
    1: 'recent',
};
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_LABEL_STRING_KEY = {
    0: 'related-posts.title',
    1: 'recent-posts.title',
};
/** @deprecated use {@link RelatedPostsLabel} */
export const RELATED_POSTS_LABEL_OPTION = RELATED_POSTS_LABEL_OPTIONS.related;
/** @deprecated use {@link relatedPostsWidgetStyleParams} */
export const RELATED_POSTS_SETTINGS_PARAMS = {
    postCount: {
        wixParam: 'post-list-postCount',
        appSettingsPath: 'style.numbers.post-list-postCount',
        defaultValue: 3,
        minValue: 1,
        maxValue: 50,
    },
};
export const relatedPostsDisplayParamsByDevice = {
    desktop: {
        seeAllLinkEnabled: relatedPostsWidgetStyleParams['see-all-link-enabled'],
        widgetTitleEnabled: relatedPostsWidgetStyleParams['widget-title-enabled'],
    },
    mobile: {
        seeAllLinkEnabled: relatedPostsWidgetStyleParams['see-all-link-mobile-enabled'],
        widgetTitleEnabled: relatedPostsWidgetStyleParams['widget-title-mobile-enabled'],
    },
};
/** @deprecated use {@link relatedPostsDisplayParamsByDevice} */
export const RELATED_POSTS_DISPLAY_PARAMS = {
    seeAllLinkEnabled: {
        wixParam: 'see-all-link-enabled',
        appSettingsPath: 'style.booleans.see-all-link-enabled',
        defaultValue: true,
    },
    widgetTitleEnabled: {
        wixParam: 'widget-title-enabled',
        appSettingsPath: 'style.booleans.widget-title-enabled',
        defaultValue: true,
    },
};
/** @deprecated use {@link relatedPostsDisplayParamsByDevice} */
export const RELATED_POSTS_DISPLAY_PARAMS_MOBILE = {
    seeAllLinkEnabled: {
        wixParam: 'see-all-link-mobile-enabled',
        appSettingsPath: 'style.booleans.see-all-link-mobile-enabled',
        defaultValue: true,
    },
    widgetTitleEnabled: {
        wixParam: 'widget-title-mobile-enabled',
        appSettingsPath: 'style.booleans.widget-title-mobile-enabled',
        defaultValue: true,
    },
};
/** @deprecated use {@link relatedPostsWidgetStyleParamsByDevice} */
export const RELATED_POSTS_LAYOUT_PARAMS = {
    widgetBackgroundColor: {
        wixParam: 'widget-backgroundColor',
        appSettingsPath: 'style.colors.widget-backgroundColor',
        defaultValue: 'color-1',
        defaultOpacity: 0,
    },
    sliderLoop: {
        wixParam: 'slider-loop',
        appSettingsPath: 'style.booleans.slider-loop',
        defaultValue: false,
    },
    sliderAutoSlide: {
        wixParam: 'slider-autoSlide',
        appSettingsPath: 'style.booleans.slider-autoSlide',
        defaultValue: false,
    },
    sliderPauseTime: {
        wixParam: 'slider-pauseTime',
        appSettingsPath: 'style.numbers.slider-pauseTime',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    sliderShowArrows: {
        wixParam: 'slider-showArrows',
        appSettingsPath: 'style.booleans.slider-showArrows',
        defaultValue: true,
    },
    sliderArrowsPosition: {
        wixParam: 'slider-arrowsPosition',
        appSettingsPath: 'style.numbers.slider-arrowsPosition',
        defaultValue: 0,
        values: {
            ON_GALLERY: 0,
            OUTSIDE_GALLERY: 1,
        },
    },
    sliderArrowsSize: {
        wixParam: 'slider-arrowsSize',
        appSettingsPath: 'style.numbers.slider-arrowsSize',
        defaultValue: 18,
        minValue: 6,
        maxValue: 180,
    },
    sliderArrowsColor: {
        wixParam: 'slider-arrowsColor',
        appSettingsPath: 'style.colors.slider-arrowsColor',
        defaultValue: 'color-5',
    },
};
/** @deprecated use {@link relatedPostsWidgetStyleParamsByDevice} */
export const RELATED_POSTS_LAYOUT_PARAMS_MOBILE = {
    widgetBackgroundColor: {
        wixParam: 'widget-mobile-backgroundColor',
        appSettingsPath: 'style.colors.widget-mobile-backgroundColor',
        defaultValue: 'color-1',
        defaultOpacity: 0,
    },
    sliderLoop: {
        wixParam: 'slider-mobile-loop',
        appSettingsPath: 'style.booleans.slider-mobile-loop',
        defaultValue: false,
    },
    sliderAutoSlide: {
        defaultValue: true,
        wixParam: 'slider-mobile-autoSlide',
        appSettingsPath: 'style.booleans.slider-mobile-autoSlide',
    },
    sliderPauseTime: {
        wixParam: 'slider-mobile-pauseTime',
        appSettingsPath: 'style.numbers.slider-mobile-pauseTime',
        defaultValue: 4,
        minValue: 1,
        maxValue: 10,
    },
    sliderShowArrows: {
        wixParam: 'slider-mobile-showArrows',
        appSettingsPath: 'style.booleans.slider-mobile-showArrows',
        defaultValue: true,
    },
    sliderArrowsPosition: {
        wixParam: 'slider-mobile-arrowsPosition',
        appSettingsPath: 'style.numbers.slider-mobile-arrowsPosition',
        defaultValue: 0,
        values: {
            ON_GALLERY: 0,
            OUTSIDE_GALLERY: 1,
        },
    },
    sliderArrowsSize: {
        wixParam: 'slider-mobile-arrowsSize',
        appSettingsPath: 'style.numbers.slider-mobile-arrowsSize',
        defaultValue: 18,
        minValue: 6,
        maxValue: 180,
    },
    sliderArrowsColor: {
        wixParam: 'slider-mobile-arrowsColor',
        appSettingsPath: 'style.colors.slider-mobile-arrowsColor',
        defaultValue: 'color-5',
    },
};
export const seeAllLinkButtonDesignParams = {
    verticalPadding: relatedPostsWidgetStyleParams['see-all-link-button-verticalPadding'],
    horizontalPadding: relatedPostsWidgetStyleParams['see-all-link-button-horizontalPadding'],
    textFont: relatedPostsWidgetStyleParams['see-all-link-button-textFont'],
    textColor: relatedPostsWidgetStyleParams['see-all-link-button-textColor'],
    uppercase: relatedPostsWidgetStyleParams['see-all-link-button-uppercase'],
    backgroundColor: relatedPostsWidgetStyleParams['see-all-link-button-backgroundColor'],
    cornerRadius: relatedPostsWidgetStyleParams['see-all-link-button-cornerRadius'],
    borderColor: relatedPostsWidgetStyleParams['see-all-link-button-borderColor'],
    borderWidth: relatedPostsWidgetStyleParams['see-all-link-button-borderWidth'],
    textColorHover: relatedPostsWidgetStyleParams['see-all-link-button-textColorHover'],
    backgroundColorHover: relatedPostsWidgetStyleParams['see-all-link-button-backgroundColorHover'],
    borderColorHover: relatedPostsWidgetStyleParams['see-all-link-button-borderColorHover'],
};
export const widgetTitleDesignParams = {
    textFont: relatedPostsWidgetStyleParams['widget-title-textFont'],
    textColor: relatedPostsWidgetStyleParams['widget-title-textColor'],
};
//# sourceMappingURL=post-list.wix-params.js.map